import { TableDataItem } from "../../../types";
import { DefaultWellTestFormData } from "../../../types/wellTestTypes";

export const mapDefaultWellTestTableDataToForm = (data: TableDataItem): Partial<DefaultWellTestFormData> => {
    return {
        testDate: data.TestDate || '',
        duration: data.Duration?.toString() || '',
        oilRate: data.OilRate?.toString() || '',
        waterRate: data.WaterRate?.toString() || '',
        gasRate: data.GasRate?.toString() || '',
        tubingPressure: data.TubingPressure?.toString() || '',
        casingPressure: data.CasingPressure?.toString() || '',
        runtime: data.Runtime?.toString() || '',
        strokeLength: data.StrokeLength?.toString() || '',
        fluidAbovePump: data.FluidAbovePump?.toString() || '',
        pumpsize: data.Pumpsize?.toString() || '',
        spm: data.SPM?.toString() || '',
        flowlineTemp: data.FlowlineTemp?.toString() || '',
        casingTemp: data.CasingTemp?.toString() || '',
        waterSG: data.WaterSG?.toString() || '',
        oilAPIGravity: data.OilAPIGravity?.toString() || '',
        co2: data.CO2?.toString() || '',
        highPressureGasRate: data.HighPressureGasRate?.toString() || '',
        casingGasRate: data.CasingGasRate?.toString() || '',
        gasLiftGasRate: data.GasLiftGasRate?.toString() || '',
        flowlinePressure: data.FlowlinePressure?.toString() || '',
        tubingTemp: data.TubingTemp?.toString() || '',
        pumpIntakePressure: data.PumpIntakePressure?.toString() || '',
        pumpDischargePressure: data.PumpDischargePressure?.toString() || '',
        pumpIntakeTemp: data.PumpIntakeTemp?.toString() || '',
        motorTemp: data.MotorTemp?.toString() || '',
        driveCurrent: data.DriveCurrent?.toString() || '',
        driveSpeed: data.DriveSpeed?.toString() || '',
        rodRPM: data.RodRPM?.toString() || '',
        rodTorque: data.RodTorque?.toString() || '',
        triplexDischargePressure: data.TriplexDischargePressure?.toString() || '',
        suctionPressure: data.SuctionPressure?.toString() || '',
        linePressureToSetting: data.LinePressureToSetting?.toString() || '',
        wellId: data.WellId || null,
        id: data.Id || 0,
    };
};